import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/didiAlarm/group/list',
    name: 'didiAlarmGroupList',
    component: () => import('@/views/apply/didiAlarm/group/list/index'),
    meta: {
      title: i18n.t('router.didiAlarm.group_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/didiAlarm/group/config',
    name: 'didiAlarmGroupConfig',
    component: () => import('@/views/apply/didiAlarm/group/config'),
    meta: {
      title: i18n.t('router.didiAlarm.basic_setting'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/didiAlarm/alarm/list',
    name: 'didiAlarmList',
    component: () => import('@/views/apply/didiAlarm/alarm/list/index'),
    meta: {
      title: i18n.t('router.didiAlarm.call_record_list'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/didiAlarm/alarm/detail',
    name: 'didiAlarmDetail',
    component: () => import('@/views/apply/didiAlarm/alarm/detail/index'),
    meta: {
      title: i18n.t('router.didiAlarm.call_record_detail'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/didiAlarm/receiver/list',
    name: 'didiAlarmReceiverList',
    component: () => import('@/views/apply/didiAlarm/receiver/list/index'),
    meta: {
      title: i18n.t('router.didiAlarm.receiver_manage'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/didiAlarm.js